export default __webpack_public_path__ + "b51f6f4aed3aa02356d8f9d8e6039985.png";